/**
 * @voltxampere/ui — Trigger marker glyphs (Sprint 15)
 *
 * Two visual hints overlaid on the trace:
 *
 *   - **Threshold line** — a horizontal dashed line at the trigger
 *     threshold voltage on the trigger source channel. Lets the
 *     user eyeball whether the current sweep crosses the threshold
 *     near where they expected.
 *   - **Trigger marker arrow** — a small triangle anchored to the
 *     trigger event time on the bottom edge of the canvas. Sprint
 *     15 uses an upward-pointing brass arrow per Zenit voice.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */
import { colourForChannel } from "./trace.js";
export function drawTriggerLine(ctx, opts) {
    const { threshold, channelId, canvasWidth, canvasHeight, voltageToScreen, theme } = opts;
    const y = voltageToScreen(threshold, channelId);
    if (!Number.isFinite(y))
        return;
    if (y < 0 || y > canvasHeight)
        return;
    ctx.save();
    ctx.strokeStyle = colourForChannel(channelId, theme);
    ctx.globalAlpha = 0.6;
    ctx.lineWidth = 1;
    ctx.lineCap = "square";
    // Optional dashed effect — guard for mocks without setLineDash.
    const dashable = ctx;
    dashable.setLineDash?.([4, 3]);
    ctx.beginPath();
    ctx.moveTo(0, y);
    ctx.lineTo(canvasWidth, y);
    ctx.stroke();
    dashable.setLineDash?.([]);
    ctx.restore();
}
export function drawTriggerArrow(ctx, opts) {
    const { time, canvasWidth, canvasHeight, timeToScreen, theme } = opts;
    const x = timeToScreen(time);
    if (!Number.isFinite(x))
        return;
    if (x < 0 || x > canvasWidth)
        return;
    ctx.save();
    ctx.fillStyle = theme.accent.brass;
    ctx.strokeStyle = theme.accent.brassHot;
    ctx.lineWidth = 1;
    // Upward arrow at the bottom edge.
    const half = 5;
    const y = canvasHeight - 0.5;
    ctx.beginPath();
    ctx.moveTo(x, y - 8);
    ctx.lineTo(x - half, y);
    ctx.lineTo(x + half, y);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
}
//# sourceMappingURL=trigger-marker.js.map